(function(){
    $('.modal-trigger.restore-cart').each(function(_, element) {
        var $el = $(element);
        $el.click(function(e) {
            $(e.currentTarget).closest('form').submit();
            return false;
        });
    });
})();
